<template>
    <div class="ah-page application-form-management">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>申報文件管理</h1>
                    </div>
                    <div class="actions">
                        <el-button type="highlight" @click="onOpenUploadDialog">上傳文件</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body" style="padding-bottom: 0">
                    <div class="tool-block">
                        <el-form label-position="top" class="form">
                            <el-form-item label="所屬年度">
                                <el-select v-model="queryParams.year" placeholder="年度" style="width: 100px" size="small" @change="updateData(true)">
                                    <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="申報類別">
                                <el-select v-model="queryParams.typ" style="width: 130px" size="small" @change="updateData(true)">
                                    <el-option v-for="item in typList" :key="item.key" :label="item.label" :value="item.key" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="關鍵字">
                                <el-input v-model="queryParams.keyword" style="width: 230px" size="small" placeholder="關鍵字：文件名稱、系統編號" @keyup.enter.native="updateData(true)">
                                    <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="updateData(true)" />
                                </el-input>
                            </el-form-item>
                        </el-form>
                        <div class="download-btn">
                            <el-button v-if="selectedItems.length" :loading="isLoading" size="small" @click="onDownload">批次下載</el-button>
                        </div>
                    </div>
                </div>
                <div class="panel-body" style="padding-top: 0">
                    <el-table v-loading="isLoading" :data="datas" ref="table" empty-text="無資料" style="width: 100%" @selection-change="onSelectionChange">
                        <el-table-column key="selection" type="selection" width="50"></el-table-column>
                        <el-table-column prop="documentNumber" label="系統編號" width="150" />
                        <el-table-column prop="year" label="所屬年" width="80" />
                        <el-table-column prop="period" label="所屬期別" width="80" :show-overflow-tooltip="true" min-width="150">
                            <template slot-scope="scope">
                                {{ getPeriodTxt(scope.row) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="typ" label="申報類型" width="120" :show-overflow-tooltip="true" min-width="150">
                            <template slot-scope="scope">
                                {{ getTypTxt(scope.row.typ) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="nam" label="文件名稱" min-width="200">
                            <template slot-scope="scope">
                                <div>
                                    <a :href="scope.row.url" target="_blank" style="color: #6f3dd9; text-decoration: none">{{ scope.row.nam }}</a>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fileTyp" label="檔案類型" width="80">
                            <template slot-scope="scope">
                                <span>{{ getFileTyp(scope.row.url) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="filesize" label="檔案大小" width="90">
                            <template slot-scope="scope">
                                {{ getFileSize(scope.row.filesize) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="crT_USR" label="上傳人" width="80" />
                        <el-table-column prop="crT_DAT" label="上傳日期" width="100">
                            <template slot-scope="scope">
                                <span>{{ scope.row.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column prop="unPayAmount" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button type="text" @click="onEdit(scope.row)">編輯</el-button>
                                <el-button type="text" @click="onDelete(scope.row)">刪除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="download-btn" style="margin-top: 20px">
                        <el-button v-if="selectedItems.length" :loading="isLoading" size="small" @click="onDownload">批次下載</el-button>
                    </div>

                    <div class="pagination">
                        <el-pagination
                            layout="prev, pager, next"
                            :page-size.sync="queryParams.PageSize"
                            :total.sync="totalDataCount"
                            :current-page.sync="queryParams.PageNum"
                            @current-change="updateData(false)"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <DetailDialog :visible="detailDialog.visible" :sno="detailDialog.sno" @close="onDetailClose" />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { applicationFormTypOptions } from '@/assets/commonData/options';
import DetailDialog from './DetailDialog.vue';

export default {
    components: { DetailDialog },
    data() {
        return {
            isLoading: false,
            queryParams: {
                year: null,
                typ: null,
                keyword: null,
                PageSize: 50,
                PageNum: 1,
            },
            totalDataCount: 0,
            detailDialog: {
                visible: false,
                sno: null,
            },

            yearList: [],
            typList: [{ key: null, label: '不限' }, ...applicationFormTypOptions],
            datas: [],
            selectedItems: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            const THIS_YEAR = moment().year();
            for (let y = THIS_YEAR; y >= 2020; y -= 1) {
                this.yearList.push(y);
            }
            this.queryParams.year = THIS_YEAR;

            await this.updateData(true);
        },
        async updateData(initPageNum) {
            if (initPageNum) this.queryParams.PageNum = 1;

            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'Document/QueryDocuments',
                    method: 'GET',
                    params: this.queryParams,
                });
                this.datas = resp.data.items;
                this.totalDataCount = resp.data.totalNum;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        onOpenUploadDialog() {
            this.detailDialog.visible = true;
        },
        onSelectionChange(selections) {
            this.selectedItems = selections;
        },
        onEdit(row) {
            this.detailDialog.visible = true;
            this.detailDialog.sno = row.sno;
        },
        async onDelete(row) {
            try {
                await this.$confirm('確定要刪除此文件？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isLoading = true;
                await this.$api({
                    url: 'Document/DeleteDocument',
                    method: 'DELETE',
                    data: { sno: row.sno },
                });
                this.updateData(true);
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        onDetailClose(refresh) {
            this.detailDialog.visible = false;
            this.detailDialog.sno = null;
            if (refresh) this.updateData(true);
        },

        getPeriodTxt({ period, typ }) {
            switch (typ) {
            case 1:
                return `${period * 2 - 1}~${period * 2}月`;

            case 2:
            case 5:
                return `${period}月`;
            default:
                return period ? `${period}月` : '全年';
            }
        },
        getFileTyp(file) {
            const URL_SPLIT = file.split('/');
            const FILE = _.last(URL_SPLIT);
            const FILE_SPLIT = FILE.split('.');
            const FILE_TYP = this.getBase64FileTyp(_.last(FILE_SPLIT));

            return FILE_TYP.toUpperCase();
        },
        getFileSize(filesize) {
            if (filesize > 1000 && filesize < 1000 * 1000) return `${Math.round((filesize / 1000) * 10) / 10} KB`;
            if (filesize > 1000 * 1000) return `${Math.round((filesize / (1000 * 1000)) * 10) / 10} MB`;
            return `${filesize} B`;
        },

        async onDownload() {
            try {
                this.isLoading = true;
                const query = this.getManualQuery(this.prevQuery);
                const dataResp = await this.$api({
                    url: `Document/ExportQueryDocuments${query}`,
                    method: 'GET',
                });

                // eslint-disable-next-line global-require
                const JSZip = require('jszip');
                const zip = new JSZip();
                const folder = zip.folder('test txt');

                // push files
                dataResp.data.items.forEach((f) => {
                    const { blob, type } = this.dataURItoBlob(f.base64Url);
                    const typeTxt = this.getBase64FileTyp(type.split('/')[1]);

                    folder.file(`${f.nam}.${typeTxt}`, blob, { binary: true });
                });

                // download
                zip.generateAsync({ type: 'blob' }).then((content) => {
                    window.open(URL.createObjectURL(content));
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        dataURItoBlob(dataURI) {
            const byteString = atob(dataURI.split(',')[1]);
            const type = dataURI.split(',')[0].split(':')[2].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i += 1) {
                ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type });
            return { blob, type };
        },
        getManualQuery() {
            const returnValue = [..._.map(this.selectedItems, (o) => `Snos=${o.sno}`)];
            return returnValue.length ? `?${returnValue.join('&')}` : '';
        },
        getBase64FileTyp(mime) {
            switch (mime) {
            case 'plain':
                return 'txt';
            case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return 'xlsx';
            case 'vnd.ms-excel':
                return 'xls';
            default:
                return mime;
            }
        },
        getTypTxt(typ) {
            return _.find(applicationFormTypOptions, ['key', typ]).label;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.application-form-management {
    .tool-block {
        .form {
            display: flex;
            > :not(:last-child) {
                margin-right: 15px;
            }
        }
        .export-tool-block > * {
            display: flex;
            align-items: center;
            &:first-child {
                margin-bottom: 10px;
            }
            .label {
                margin-right: 10px;
            }
        }
    }
    .download-btn {
        height: 32px;
    }
}
</style>
